import { render, staticRenderFns } from "./channel-categories.vue?vue&type=template&id=b81bd9dc&scoped=true&lang=pug"
import script from "./channel-categories.vue?vue&type=script&lang=js"
export * from "./channel-categories.vue?vue&type=script&lang=js"
import style0 from "./channel-categories.vue?vue&type=style&index=0&id=b81bd9dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81bd9dc",
  null
  
)

export default component.exports